import React from 'react'
import EnrollIndividual from '../views/payments/components/enroll-individual'
import { useSelector } from 'react-redux';
import EnrollCorporate from '../views/payments/components/enroll-corporate';
import { config } from '../common/constant';
import SkipEnrollment from './skip-enollment';


const Enrollment = ({ setHeaderData }) => {
    const user = useSelector((state) => state.userReducer)
    const isBussiness = user.isBusinessPayer
    const isSearchByNric = user.isSearchByNric
    const isSingpass = user?.userData?.flow === config.FLOW.SINGPASS
    const isAnonymous = user?.userData?.flow === config.FLOW.ANONYMOUS
    if (isSearchByNric || isSingpass || isAnonymous) {

        return (
            <SkipEnrollment setHeaderData={setHeaderData}/>
        )
    }
    return (
        <div>
            {
                isBussiness ?
                    <EnrollCorporate setHeaderData={setHeaderData} /> : <EnrollIndividual setHeaderData={setHeaderData} />

            }
        </div>
    )

}

export default Enrollment